import * as React from 'react'
import type { AnnouncementItemDetailProps } from './AnnouncementItem.types'
import { cn } from '@core/utils'
import Image from '../Image/Image'

const AnnouncementItemDetail: React.FC<AnnouncementItemDetailProps> = ({
    title,
    description,
    logo,
    image,
    companyName,
    companyDescription,
    layoutHeaderClassName,
    layoutHeaderProps,
    backgroundImageClassName,
    backgroundImageProps,
    layoutHeaderContentClassName,
    layoutHeaderContentProps,
    logoClassName,
    logoProps,
    layoutHeaderInformationClassName,
    layoutHeaderInformationProps,
    layoutHeaderInformationTitleClassName,
    layoutHeaderInformationTitleProps,
    layoutHeaderInformationDescriptionClassName,
    layoutHeaderInformationDescriptionProps,
    layoutContentClassName,
    layoutContentProps,
    layoutContentTitleClassName,
    layoutContentTitleProps,
    layoutContentDescriptionClassName,
    layoutContentDescriptionProps,
    className,
    ...props
}) => {
    return (
        <div className={cn(className)} {...props}>
            <div
                className={cn(
                    'relative flex h-[265px] px-3 py-4',
                    "before:absolute before:inset-0 before:z-0 before:content-['']",
                    'before:bg-[linear-gradient(0deg,rgba(0,0,0,0.8)_0%,rgba(0,0,0,0.5)_50%,rgba(0,0,0,0)_100%)]',
                    layoutHeaderClassName,
                )}
                {...layoutHeaderProps}>
                <Image
                    src={image || ''}
                    alt={title}
                    className={cn(
                        'absolute inset-0 -z-10 h-full w-full rounded-[20px] object-cover',
                        backgroundImageClassName,
                    )}
                    {...backgroundImageProps}
                />
                <div
                    className={cn(
                        'z-10 mt-auto flex items-center gap-3',
                        layoutHeaderContentClassName,
                    )}
                    {...layoutHeaderContentProps}>
                    <Image
                        src={logo}
                        alt={companyName}
                        className={cn('size-14 rounded-full', logoClassName)}
                        {...logoProps}
                    />
                    <div
                        className={cn(
                            'space-y-[2px]',
                            layoutHeaderInformationClassName,
                        )}
                        {...layoutHeaderInformationProps}>
                        <h2
                            className={cn(
                                '!text-display-lg-b text-semantic-content-inkInverse',
                                layoutHeaderInformationTitleClassName,
                            )}
                            {...layoutHeaderInformationTitleProps}>
                            {companyName}
                        </h2>
                        <p
                            className={cn(
                                '!text-body-sm-r text-semantic-content-inkInverse',
                                layoutHeaderInformationDescriptionClassName,
                            )}
                            {...layoutHeaderInformationDescriptionProps}>
                            {companyDescription}
                        </p>
                    </div>
                </div>
            </div>
            <div
                className={cn(
                    'space-y-1 px-4 pb-6 pt-5',
                    layoutContentClassName,
                )}
                {...layoutContentProps}>
                <h3
                    className={cn(
                        '!text-display-md-b text-semantic-content-inkInverse',
                        layoutContentTitleClassName,
                    )}
                    {...layoutContentTitleProps}>
                    {title}
                </h3>
                <p
                    className={cn(
                        '!text-body-sm-r text-semantic-content-inkInverse',
                        layoutContentDescriptionClassName,
                    )}
                    dangerouslySetInnerHTML={{ __html: description }}
                    {...layoutContentDescriptionProps}
                />
            </div>
        </div>
    )
}

AnnouncementItemDetail.displayName = 'AnnouncementItemDetail'

export default AnnouncementItemDetail
